<template>

<div>
  <PageTitle :route="$route">
    <template slot="action-button">
      <ActionButton
        id="showModalExtractNotLinkedOs"
        icon="fa-plus"
      />
    </template>
  </PageTitle>

  <PageRowWrapper>
    <div class="col-sm-12">
      <ExtractAdd />
    </div>
  </PageRowWrapper>
</div>

</template>

<script>
import PageTitle from '@/components/layout/PageTitle'
import PageRowWrapper from '@/components/layout/PageRowWrapper'
import ExtractAdd from '@/components/extract/ExtractAdd'
import ActionButton from '@/components/button/ActionButton'

export default {
  name: 'AddExtract',
  components: {
    PageTitle,
    PageRowWrapper,
    ExtractAdd,
    ActionButton
  }
}
</script>
